<template>
  <div :id="blok.id" v-editable="blok" class="marketing-text-hero-blok">
    <AppTextHero :has-actions="Boolean(blok.actions?.length)" :title :description>
      <template #actions>
        <div v-if="blok.actions?.length" class="flex flex-wrap gap-2">
          <StoryblokComponent
            v-for="item in blok.actions"
            :key="item._uid"
            :blok="item"
            data-analytics-action="click"
            data-analytics-category="in-page"
            :data-analytics-label="item.text"
          />
        </div>
      </template>

      <template #actions-footer>
        <div v-if="blok.actions_footer?.length" class="flex flex-wrap gap-2">
          <StoryblokComponent
            v-for="item in blok.actions_footer"
            :key="item._uid"
            :blok="item"
            data-analytics-action="click"
            data-analytics-category="in-page"
            :data-analytics-label="item.text"
          />
        </div>
      </template>
    </AppTextHero>
  </div>
</template>

<script lang="ts" setup>
  const { blok } = defineProps<{ blok: MarketingTextHeroBlokStoryblok }>();
  const title = computed(() => renderRichText(blok.title) ?? '');
  const description = computed(() => renderRichText(blok.description) ?? '');
</script>
